import { React, useState, useEffect, useRef } from "react";
import * as ReactDOM from "react-dom";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
  GridPageChangeEvent,
} from "@progress/kendo-react-grid";
import { Input } from "@progress/kendo-react-inputs";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { GridHelper } from "../Common/Components/GridHelper";
import { ColumnMenu } from "../Common/Components/ColumnMenu";
import {
  GridColumnMenuFilter,
  GridColumnMenuCheckboxFilter,
} from "@progress/kendo-react-grid";

import {
  Menu,
  MenuItem,
  MenuItemLink,
  MenuSelectEvent,
} from "@progress/kendo-react-layout";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { PagerTargetEvent } from "@progress/kendo-react-data-tools";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";
import { DropDownList, ComboBox } from "@progress/kendo-react-dropdowns";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../Core/store.hooks";
import {  getSearchSelector } from "./SearchSlice";

import { useNavigate, createSearchParams } from "react-router-dom";

const initialSort: any[] = [
  {
    field: "customerName",
    dir: "asc",
  },
];

interface CustomerGridProps {
  data?: any | null;
  recent?: boolean | null;
}

const CustomerGrid = (props: CustomerGridProps) => {
  const [data, setData] = useState(props.data);
  const [sort, setSort] = useState(initialSort);
  const [isPagable, updateIsPagable] = useState();
  const [pageSizeValue, setPageSizeValue] = useState();
  const [page, setPage] = useState({
    skip: 0,
    take: 15,
  });
  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take = targetEvent.value === "All" ? data.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const params = useSelector(getSearchSelector);

  const countryFilter = useSelector(getSearchSelector).country;

    useEffect(() => {
    if (params != null && props.data != null) {
      filterData(params);
    }
  }, [params, props.data]);
  useEffect(() => {
    if (props.recent) {
      updateIsPagable(false);
    } else {
      updateIsPagable(true);
    }
  }, []);
  //useEffect(() => {
  //    if (countryFilter!= null) {
  //        filterCountry(countryFilter)
  //        }

  //}, [countryFilter])

  const ColumnMenuCheckboxFilter = (props) => {
    return (
      <div>
        <GridColumnMenuCheckboxFilter {...props} data={data} expanded={true} />
      </div>
    );
  };

  const ColumnHeader = (props) => {
    return (
      <span
        style={{
          fontWeight: "bold",
        }}
      >
        {props.title}
      </span>
    );
  };
  function searchByRemoteGateway(x, remoteGatewayFilter) {
    if (remoteGatewayFilter == "All") {
      return true;
    }
    if (x.phoneTypes != null) {
      if (remoteGatewayFilter == "Secomea") {
        if (x.phoneTypes.indexOf(6) > -1) {
          return true;
        }
      } else if (remoteGatewayFilter == "Tosibox") {
        if (x.phoneTypes.indexOf(5) > -1) {
          return true;
        }
      } else if (remoteGatewayFilter == "Secomea or Tosibox") {
        if (x.phoneTypes.indexOf(5) > -1 || x.phoneTypes.indexOf(6) > -1) {
          return true;
        }
      } else if (remoteGatewayFilter == "Secomea and Tosibox") {
        if (x.phoneTypes.indexOf(5) > -1 && x.phoneTypes.indexOf(6) > -1) {
          return true;
        }
      } else if (remoteGatewayFilter == "None") {
        if (
          !(x.phoneTypes.indexOf(5) > -1) &&
          !(x.phoneTypes.indexOf(6) > -1)
        ) {
          return true;
        }
      }
    }
    return false;
  }
  function searchByDataSource(x, dataSourceFilter) {
    if (dataSourceFilter == "All") {
      return true;
    } else if (dataSourceFilter == "D365") {
      if (x.dataSource == "D365") {
        return true;
      }
    } else if (dataSourceFilter == "MPE") {
      if (x.dataSource == "MPE") {
        return true;
      }
    } else if (dataSourceFilter == "Axapta Archive") {
      if (x.dataSource == "Axapta") {
        return true;
      }
    } else if (dataSourceFilter == "MPE , D365") {
      if (x.dataSource == "MPE" || x.dataSource == "D365") {
        return true;
      }
    }
    return false;
  }
  function searchBySerial(x, machineSerialFilter) {
    if (machineSerialFilter == "" || machineSerialFilter == null) return true;
    if (x.machines == null || x.machines == undefined) return false;
    if (x.machines.length < 1) return false;
    for (var i = 0; i < x.machines.length; i++) {
      const assemblyName =
        x.machines[i].assemblyName != null
          ? x.machines[i].assemblyName.toLowerCase()
          : "";
      const machineSerialFull =
        assemblyName != null
          ? assemblyName + " " + x.machines[i].machineSn.toLowerCase()
          : x.machines[i].machineSn.toLowerCase();

      if (
        machineSerialFull.indexOf(machineSerialFilter.trim().toLowerCase()) != -1 ||
        machineSerialFilter == null ||
        machineSerialFilter == ""
      ) {
        return true;
      }
      if (
        x.machines[i].deviceSerials != null &&
        x.machines[i].deviceSerials != undefined
      ) {
        for (var k = 0; k < x.machines[i].deviceSerials.length; k++) {
          if (x.machines[i].deviceSerials[k] != null) {
            if (
              x.machines[i].deviceSerials[k]
                .toLowerCase()
                .indexOf(machineSerialFilter.trim().toLowerCase()) != -1
            ) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }
  function searchByProjectNr(x, projectNrFilter) {
    if (projectNrFilter == "" || projectNrFilter == null) return true;
    if (x.machines == null || x.machines == undefined) return false;
    if (x.machines.length < 1) return false;
    for (var i = 0; i < x.machines.length; i++) {
      if (
        x.machines[i].projectNr != null &&
        x.machines[i].projectNr != "" &&
        x.machines[i].projectNr != undefined
      ) {
        if (
          x.machines[i].projectNr
            .toLowerCase()
            .indexOf(projectNrFilter.toLowerCase()) != -1
        ) {
          return true;
        }
      }
    }
    return false;
  }
  function filterByAll(dataRow, value) {
    if (dataRow.customerID.toLowerCase().includes(value.toLowerCase())) {
      return true;
    }
    if (dataRow.customerName.toLowerCase().includes(value.toLowerCase())) {
      return true;
    }
    if (dataRow.customerID.toLowerCase().includes(value.toLowerCase())) {
      return true;
    }
    if (dataRow.country != null) {
      if (dataRow.country.toLowerCase().includes(value.toLowerCase())) {
        return true;
      }
    }
    if (dataRow.customerID_Italy != null) {
      if (
        dataRow.customerID_Italy.toLowerCase().includes(value.toLowerCase())
      ) {
        return true;
      }
    }

    return false;
  }
  const filterData = (value) => {
    let filter: any = {
      logic: "or",
      filters: [
        {
          field: "customerName",
          operator: "contains",
          value: value.searchAll,
        },
        {
          field: "customerID",
          operator: "contains",
          value: value.searchAll,
        },
        {
          field: "country",
          operator: "contains",
          value: value.searchAll,
        },
      ],
    };
    let customerIDFilter: any = {
      logic: "or",
      filters: [
        {
          field: "customerID",
          operator: "contains",
          value: value.customerID,
        },
        {
          field: "customerID_Italy",
          operator: "contains",
          value: value.customerID,
        },
      ],
    };
    let countryFilter: any = {
      logic: "or",
      filters: [
        {
          field: "country",
          operator: "contains",
          value: value.country,
        },
      ],
    };
    let newData = props.data;
    if (value.country != "") {
      newData = filterBy(newData, countryFilter);
    }
    if (value.customerID != "") {
      newData = filterBy(newData, customerIDFilter);
    }

    if (value.machineSerial != "") {
      let machineSerialTrue = [];

      for (var i = 0; i < newData.length; i++) {
        if (searchBySerial(newData[i], value.machineSerial)) {
          machineSerialTrue.push(newData[i]);
        }
      }
      newData = machineSerialTrue;
    }
    if (value.remoteGateway != null && value.remoteGateway != "All") {
      let remoteGatewayTrue = [];
      for (var i = 0; i < newData.length; i++) {
        if (searchByRemoteGateway(newData[i], value.remoteGateway)) {
          remoteGatewayTrue.push(newData[i]);
        }
      }
      newData = remoteGatewayTrue;
    }
    if (value.dataSource != null && value.dataSource != "All") {
      let dataSourceTrue = [];
      for (var i = 0; i < newData.length; i++) {
        if (searchByDataSource(newData[i], value.dataSource)) {
          dataSourceTrue.push(newData[i]);
        }
      }
      newData = dataSourceTrue;
    }
    if (value.projectNr != "") {
      let projectNrTrue = [];

      for (var i = 0; i < newData.length; i++) {
        if (searchByProjectNr(newData[i], value.projectNr)) {
          projectNrTrue.push(newData[i]);
        }
      }
      newData = projectNrTrue;
    }
    if (value.searchAll != "") {
      let rowTrue = [];

      for (var i = 0; i < newData.length; i++) {
        if (
          searchByProjectNr(newData[i], value.searchAll) ||
          searchBySerial(newData[i], value.searchAll) ||
          filterByAll(newData[i], value.searchAll)
        ) {
          rowTrue.push(newData[i]);
        }
      }
      newData = rowTrue;
    }
    setPage({
      skip: 0,
      take: 15,
    });
    setData(newData);
  };

  const setRecentCustomer = (customer: any) => {
    let recentCustomers: any = JSON.parse(
      localStorage.getItem("recentCustomers2")
    );
    if (recentCustomers == null || recentCustomers == undefined)
      recentCustomers = [];
    var alreadyRecent = false;
    for (var i = 0; i < recentCustomers.length; i++) {
      if (recentCustomers[i].customerID == customer.customerID) {
        alreadyRecent = true;
        // Update if name changed etc.
        recentCustomers[i] = customer;
        // put this customer to the top of the list
        recentCustomers.splice(0, 0, recentCustomers.splice(i, 1)[0]);
      }
    }

    if (!alreadyRecent) {
      recentCustomers.unshift(customer);

      if (recentCustomers.length > 4) {
        recentCustomers.pop();
      }
      localStorage.setItem("recentCustomers2", JSON.stringify(recentCustomers));
    }
  };
  const customerHandler = (customer: any) => {
    setRecentCustomer(customer);
    //navigate("/jiraReports");
    //  navigate("/customers/customerId=" + customer.customerID);

    navigate({
      pathname: "/customers",
      search: `?${createSearchParams({ customerId: customer.customerID })}`,
    });
  };

  const machineHandler = (machine: string, customer: any) => {
    setRecentCustomer(customer);
    navigate({
      pathname: "/customers",
      search: `?${createSearchParams({
        customerId: customer.customerID,
        machine: machine,
      })}`,
    });
  };
    const getDataSource = (machine: string, customer: any) => {

        for (var i = 0; i < customer.machines.length; i++) {
            if (machine == customer.machines[i].machineSn) {
                return customer.machines[i].dataSource;
            }
        }
        return null;
    }

    const machineDataHandler = (machine: string, customer: any) => {
        let dataSource = getDataSource(machine, customer);
        setRecentCustomer(customer);
        if (dataSource == "D365") {
            alert("The selected machine serial number was not found as a main machine serial number (or assembly serial number) in Machine Analytics. It is possible the selected serial number is listed as part of a different assembly. Please check the customer's other assemblies")
        }
        else {
            if (machine != null && machine != undefined) {
                window.open(
                    "https://machinedata.powerplatform.net/customerid=" +
                    customer.customerID +
                    "&mainMachineSerialNo=" +
                    machine,
                    "_self"
                );
            }
        }
  };
    const customerNameCell = (props: any) => {
        // 1) Build the URL that “views” this customer in a standalone tab.
        //    Replace this with whatever your handler actually uses.
        const customerUrl = `/customers?customerId=${props.dataItem.customerID }`;

        // 2) Reuse whatever you had in renderLock():
        const renderLock = () => {
            if (props.dataItem.phoneTypes != null) {
                const has5 = props.dataItem.phoneTypes.indexOf(5) > -1;
                const has6 = props.dataItem.phoneTypes.indexOf(6) > -1;

                if (has5 && has6) {
                    return (
                        <>
                            <SvgIcon
                                style={{
                                    color: "#474747",
                                    fontSize: "20px",
                                    marginLeft: "5px",
                                    verticalAlign: "top",
                                    top: "2px",
                                }}
                                icon={svgIcons.lockIcon}
                                size="medium"
                            />
                            <img
                                style={{ marginLeft: "5px" }}
                                src="../../assets/img/gateway.png"
                                alt="Gateway"
                            />
                        </>
                    );
                } else if (has5) {
                    return (
                        <SvgIcon
                            style={{
                                color: "#474747",
                                fontSize: "20px",
                                marginLeft: "5px",
                                verticalAlign: "top",
                                top: "2px",
                            }}
                            icon={svgIcons.lockIcon}
                            size="medium"
                        />
                    );
                } else if (has6) {
                    return (
                        <img
                            style={{ marginLeft: "5px" }}
                            src="../../assets/img/gateway.png"
                            alt="Gateway"
                        />
                    );
                }
            }
            return null;
        };

        // 3) onClick should still call your existing handler:
        const onLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            customerHandler(props.dataItem);
        };

        return (
            <td>
                <a
                    href={customerUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={onLinkClick}
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        color: "inherit",
                        textDecoration: "none",
                        cursor: "pointer",
                    }}
                >
                    <span>{props.dataItem.customerName}</span>
                    {renderLock()}
                </a>
            </td>
        );
    };

    const machineSerialCell = (props: any) => {
        const getAssemblyName = (a: any) => {
            if (a.assemblyName != null) return a.assemblyName;
            return " ";
        };

        let newMachineList: any = [];

        if (props.dataItem.machines == null) {
            return <td></td>;
        }
        if (props.dataItem.machines.length < 1) {
            return <td></td>;
        } else if (props.dataItem.machines.length == 1) {
            return (
                <td
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                        machineHandler(props.dataItem.machines[0].machineSn, props.dataItem)
                    }
                >
                    {getAssemblyName(props.dataItem.machines[0]) +
                        " " +
                        props.dataItem.machines[0].machineSn}
                </td>
            );
        } else {
            let machines: any = [];
            for (var i = 0; i < props.dataItem.machines.length; i++) {
                let compareName: string = getAssemblyName(props.dataItem.machines[i]) + " " + props.dataItem.machines[i].machineSn;
                compareName = compareName.trim().toLowerCase();  // Convert to lowercase
                if (params.machineSerial != null && params.machineSerial !== "") {
                    if (compareName.includes(params.machineSerial.trim().toLowerCase())) {  // Convert to lowercase for comparison
                        machines.push(
                            getAssemblyName(props.dataItem.machines[i]) +
                            " " +
                            props.dataItem.machines[i].machineSn
                        );
                    }
                } else {
                    machines.push(
                        getAssemblyName(props.dataItem.machines[i]) +
                        " " +
                        props.dataItem.machines[i].machineSn
                    );
                }
            }

            const findSerial = (e) => {
                for (var i = 0; i < props.dataItem.machines.length; i++) {
                    if (
                        e ==
                        getAssemblyName(props.dataItem.machines[i]) +
                        " " +
                        props.dataItem.machines[i].machineSn
                    ) {
                        return props.dataItem.machines[i].machineSn;
                    }
                }
            };

            if (params.machineSerial != null && params.machineSerial !== "") {
                return (
                    <td style={{ cursor: "pointer" }}>
                        <ul style={{ listStyleType: 'disc', paddingLeft: '3px', marginLeft: '8px' }}>
                            {machines.map((machine, index) => (
                                <li
                                    key={index}
                                    style={{ marginBottom: '3px' }}
                                    onClick={() => machineHandler(findSerial(machine), props.dataItem)}
                                >
                                    {machine}
                                </li>
                            ))}
                        </ul>
                    </td>
                );
            }
            return (
                <td>
                    <ComboBox
                        style={{}}
                        data={machines}
                        placeholder="Select machine..."
                        onChange={(e) =>
                            machineHandler(findSerial(e.target.value), props.dataItem)
                        }
                        suggest={true}
                        filterable={true}
                        popupSettings={{ width: "auto" }}
                    />
                </td>
            );
        }
    };

    const machineDataSerialCell = (props: any) => {
        const getAssemblyName = (a: any) => {
            if (a.assemblyName != null) return a.assemblyName;
            return " ";
        };

        if (props.dataItem.machines == null) {
            return <td></td>;
        }
        if (props.dataItem.machines.length < 1) {
            return <td></td>;
        } else if (props.dataItem.machines.length == 1) {
            return (
                <td
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                        machineDataHandler(props.dataItem.machines[0].machineSn, props.dataItem)
                    }
                >
                    {getAssemblyName(props.dataItem.machines[0]) +
                        " " +
                        props.dataItem.machines[0].machineSn}
                </td>
            );
        } else {
            let machines: any = [];
            for (var i = 0; i < props.dataItem.machines.length; i++) {
                let compareName: string = getAssemblyName(props.dataItem.machines[i]) + " " + props.dataItem.machines[i].machineSn;
                compareName = compareName.trim().toLowerCase();  // Convert to lowercase
                if (params.machineSerial != null && params.machineSerial !== "") {
                    if (compareName.includes(params.machineSerial.trim().toLowerCase())) {  // Convert to lowercase for comparison
                        machines.push(
                            getAssemblyName(props.dataItem.machines[i]) +
                            " " +
                            props.dataItem.machines[i].machineSn
                        );
                    }
                } else {
                    machines.push(
                        getAssemblyName(props.dataItem.machines[i]) +
                        " " +
                        props.dataItem.machines[i].machineSn
                    );
                }
            }

            const findSerial = (e) => {
                for (var i = 0; i < props.dataItem.machines.length; i++) {
                    if (
                        e ==
                        getAssemblyName(props.dataItem.machines[i]) +
                        " " +
                        props.dataItem.machines[i].machineSn
                    ) {
                        return props.dataItem.machines[i].machineSn;
                    }
                }
            };

            if (params.machineSerial != null && params.machineSerial !== "") {
                return (
                    <td style={{ cursor: "pointer" }}>
                        <ul style={{ listStyleType: 'disc', paddingLeft: '3px', marginLeft: '8px' }}>
                            {machines.map((machine, index) => (
                                <li
                                    key={index}
                                    style={{ marginBottom: '3px' }}
                                    onClick={() => machineDataHandler(findSerial(machine), props.dataItem)}
                                >
                                    {machine}
                                </li>
                            ))}
                        </ul>
                    </td>
                );
            }
            return (
                <td>
                    <ComboBox
                        style={{}}
                        data={machines}
                        placeholder="Select machine..."
                        onChange={(e) =>
                            machineDataHandler(findSerial(e.target.value), props.dataItem)
                        }
                        suggest={true}
                        filterable={true}
                        popupSettings={{ width: "auto" }}
                    />
                </td>
            );
        }
    };

    const MachineHeader = () => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span>Machine Dashboard</span>
            <img src="/assets/img/DI_machine.png" alt="Icon" style={{ width: 20, height: 20, marginLeft: 5 }} />
         </div>
    );
    const MachineDataHeader = () => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span>Machine Anayltics</span>
            <img src="/assets/img/DI_machine data.png" alt="Icon" style={{ width: 20, height: 20, marginLeft: 5 }} />
        </div>
    );
  const dataSourceCell = (props: any) => {
    if (props.dataItem.dataSource == "Axapta") {
      return <td>Axapta Archive</td>;
    }
    return <td>{props.dataItem.dataSource}</td>;
  };
  const getHeight = () => {
    if (props.recent) {
      return "100%";
    } else {
      return "100%";
    }
  };
  const pageOptions = () => {
    if (props.recent) {
      return false;
    } else {
      var obj: any = {
        buttonCount: 4,
        pageSizes: [5, 10, 15, 20, "All"],
        pageSizeValue: pageSizeValue,
      };
      return obj;
    }
  };
  const _export = useRef<ExcelExport | null>(null);
  const excelExport = (event: MenuSelectEvent) => {
    if (event.item.text === "Export to Excel") {
      if (_export.current !== null) {
        _export.current.save();
      }
    }
  };
  const linkRender = (props: any) => {
    return (
      <MenuItemLink url={props.item.url} opened={props.opened}>
        {[renderMenuIconIfApplicable(props), props.item.text, null]}
      </MenuItemLink>
    );
  };
  function renderMenuIconIfApplicable(props: any) {
    return props.item.icon ? (
      <span
        style={{ fontSize: "16px" }}
        className={`k-icon k-i-${props.item.icon}`}
        role="presentation"
        key="0"
      />
    ) : null;
  }
    return (
        <div style={{ height: "100%", position: "relative" }} className="CustomerSearchGrid" >
      <div
        style={{
          position: "absolute",
          top: "-20px",
          left: "-20px",
        }}
      >
        <Menu openOnClick={true} onSelect={excelExport} linkRender={linkRender}>
          <MenuItem
            text=""
            icon="more-horizontal"
            data={{}}
            cssStyle={{ color: "black" }}
          >
            <MenuItem text="Export to Excel" />
          </MenuItem>
        </Menu>
      </div>
      <ExcelExport data={data} ref={_export}>
        <Grid
          data={orderBy(data, sort).slice(page.skip, page.take + page.skip)}
          skip={page.skip}
          take={page.take}
          pageable={pageOptions()}
          onPageChange={pageChange}
          total={data.length}
          sortable={true}
          sort={sort}
          onSortChange={(e: any) => {
            setSort(e.sort);
          }}
          style={{
            width: "1000px",
          }}
        >
          <Column field="country" title="Country" />
          <Column
            field="customerName"
            title="Customer Name"
            cell={customerNameCell}
          />

          <Column field="machines" title={<MachineHeader/> } cell={machineSerialCell} />
          <Column
            field="machines"
            title={<MachineDataHeader />}
            cell={machineDataSerialCell}
          />
          {/*<Column*/}
          {/*  field="dataSource"*/}
          {/*  title="Data Source"*/}
          {/*  cell={dataSourceCell}*/}
          {/*/>*/}
        </Grid>
      </ExcelExport>
    </div>
  );
};
export default CustomerGrid;
